import axios from 'axios';
import store from '../app/store';

const setAuthorization = () => {
  try {
    const token = store.getState().user.authentication.token;
    return `Bearer ${token}`;
  } catch {
    return '';
  }
};

export const config = {
  responseType: 'json',
  headers: {
    'Content-Type': 'application/problem+json',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Origin': true,
  },
};

export const instance = axios.create(config);

export const getInstance = (instanceConfig) => {
  const instance = axios.create({ ...config, ...instanceConfig });
  instance.interceptors.request.use(
    (config) => {
      return {
        ...config,
        headers: { ...config.headers, authorization: setAuthorization() },
      };
    },
    (error) => Promise.reject(error)
  );

  return instance;
};
